var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-drag-and-drop" }, [
    _c("div", { staticClass: "upload-drag-and-drop__wrapper" }, [
      _c(
        "div",
        { staticClass: "upload-drag-and-drop__entries" },
        [
          _vm.uploadedFiles.length > 0
            ? _c("upload-preview", {
                attrs: { files: _vm.uploadedFiles },
                on: { remove: _vm.removeUploadedFile },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.errorMessage
            ? _c(
                "removable-entry",
                {
                  attrs: { bold: "", color: "red" },
                  on: { close: _vm.hideErrorMessage },
                },
                [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upload-drag-and-drop__file-upload" },
        [
          _vm.loading ? _c("loading-indicator") : _vm._e(),
          _vm._v(" "),
          _c(
            "file-upload",
            {
              ref: "upload",
              staticClass: "trbo-a-file-upload__uploader",
              attrs: {
                "input-id": "file-upload",
                accept:
                  "image/png,image/gif,image/jpeg,image/webp,application/pdf",
                multiple: true,
                drop: true,
                size: _vm.maxFileSizeInBytes,
                "custom-action": _vm.uploadFile,
              },
              on: {
                "input-file": _vm.inputFile,
                "input-filter": _vm.inputFilter,
              },
              model: {
                value: _vm.files,
                callback: function ($$v) {
                  _vm.files = $$v
                },
                expression: "files",
              },
            },
            [
              _c("div", { class: _vm.classes }, [
                _c("img", {
                  staticClass: "upload-drag-and-drop__file-upload__icon",
                  attrs: { src: "/upload.svg", alt: "" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "upload-drag-and-drop__file-upload__text",
                    attrs: { id: _vm.uploadLabelId },
                  },
                  [_vm._v(_vm._s(_vm.$t("wizard.clickToAddFiles")))]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }